<template>
  <Layout>
    <div>
      <h1>My Invoices and Receipts</h1>
      
      <div class="row mb-3">
        <div class="col-md-6">
          <div class="input-group">
            <input 
              type="text" 
              class="form-control" 
              placeholder="Search invoices..."
              v-model="searchQuery"
            >
            <div class="input-group-append">
              <button class="btn btn-outline-secondary" type="button">
                <i class="fa fa-search"></i>
              </button>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <select class="form-control" v-model="selectedStatus">
            <option value="">All Status</option>
            <option value="paid">Paid</option>
            <option value="pending">Pending</option>
            <option value="overdue">Overdue</option>
          </select>
        </div>
      </div>
      
      <div class="invoice-list">
        <div class="card invoice-item" v-for="invoice in filteredInvoices" :key="invoice.id">
          <div class="card-body">
            <div class="row">
              <div class="col-md-8">
                <h5 class="card-title">{{ invoice.description }}</h5>
                <div class="invoice-details">
                  <p><strong>Invoice #:</strong> {{ invoice.invoiceNumber }}</p>
                  <p><strong>Date:</strong> {{ invoice.date }}</p>
                  <p><strong>Due Date:</strong> {{ invoice.dueDate }}</p>
                  <p><strong>Amount:</strong> <span class="amount">S${{ invoice.amount.toFixed(2) }}</span></p>
                </div>
              </div>
              <div class="col-md-4 text-right">
                <div class="invoice-status">
                  <span class="badge" :class="getStatusBadgeClass(invoice.status)">
                    {{ invoice.status.toUpperCase() }}
                  </span>
                </div>
                <div class="invoice-actions mt-3">
                  <button class="btn btn-outline-primary btn-sm" @click="viewInvoice(invoice)" v-if="invoice.status === 'paid'">
                    <i class="fa fa-eye"></i> View
                  </button>
                  <button class="btn btn-outline-success btn-sm ml-2" @click="downloadInvoice(invoice)" v-if="invoice.status === 'paid'">
                    <i class="fa fa-download"></i> Download
                  </button>
                  <button class="btn btn-primary btn-sm ml-2" @click="payInvoice(invoice)" v-if="invoice.status === 'pending'">
                    <i class="fa fa-credit-card"></i> Pay Now
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <!-- Invoice Summary -->
      <div class="row mt-4">
        <div class="col-md-4">
          <div class="card bg-primary text-white">
            <div class="card-body text-center">
              <h4>Total Paid</h4>
              <h2>S${{ totalPaid.toFixed(2) }}</h2>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="card bg-warning text-white">
            <div class="card-body text-center">
              <h4>Pending</h4>
              <h2>S${{ totalPending.toFixed(2) }}</h2>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="card bg-danger text-white">
            <div class="card-body text-center">
              <h4>Overdue</h4>
              <h2>S${{ totalOverdue.toFixed(2) }}</h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/components/Layout.vue'
import {apiService} from '@/config/api'

export default {
  name: 'Invoices',
  components: {
    Layout
  },
  data() {
    return {
      searchQuery: '',
      selectedStatus: '',
      invoices: [
        
      ]
    }
  },
  computed: {
    filteredInvoices() {
      return this.invoices.filter(invoice => {
        const matchesSearch = invoice.description.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
                             invoice.invoiceNumber.toLowerCase().includes(this.searchQuery.toLowerCase())
        const matchesStatus = !this.selectedStatus || invoice.status === this.selectedStatus
        return matchesSearch && matchesStatus
      })
    },
    totalPaid() {
      return this.invoices
        .filter(invoice => invoice.status === 'paid')
        .reduce((sum, invoice) => sum + invoice.amount, 0)
    },
    totalPending() {
      return this.invoices
        .filter(invoice => invoice.status === 'pending')
        .reduce((sum, invoice) => sum + invoice.amount, 0)
    },
    totalOverdue() {
      return this.invoices
        .filter(invoice => invoice.status === 'overdue')
        .reduce((sum, invoice) => sum + invoice.amount, 0)
    }
  },
  created() {
    this.getInvoiceList()
  },
  methods: {
    async getInvoiceList() {
      const response = await apiService.registration.getInvoiceList()
      this.invoices = response.data.data.orders
    },
    getStatusBadgeClass(status) {
      switch (status) {
        case 'paid': return 'badge-success'
        case 'pending': return 'badge-warning'
        case 'overdue': return 'badge-danger'
        default: return 'badge-secondary'
      }
    },
    viewInvoice(invoice) {
      
      alert(`查看发票详情: ${invoice.invoiceNumber}`)
    },
    downloadInvoice(invoice) {
      // 检查是否有发票文件
      if (!invoice.invoice_files) {
        alert('发票文件不存在')
        return
      }
      
      // 显示下载提示
      const downloadBtn = event.target.closest('button')
      const originalText = downloadBtn.innerHTML
      downloadBtn.innerHTML = '<i class="fa fa-spinner fa-spin"></i> Downloading...'
      downloadBtn.disabled = true
      
      try {
        // 创建下载链接
        const link = document.createElement('a')
        link.href = invoice.invoice_files
        
        // 根据文件扩展名设置下载文件名
        const fileExtension = invoice.invoice_files.split('.').pop() || 'pdf'
        link.download = `invoice_${invoice.invoiceNumber}.${fileExtension}`
        link.target = '_blank'
        
        // 添加到DOM并触发点击
        document.body.appendChild(link)
        link.click()
        
        // 清理DOM
        document.body.removeChild(link)
        
        // 恢复按钮状态
        setTimeout(() => {
          downloadBtn.innerHTML = originalText
          downloadBtn.disabled = false
        }, 2000)
        
      } catch (error) {
        console.error('下载发票失败:', error)
        alert('下载失败，请重试')
        
        // 恢复按钮状态
        downloadBtn.innerHTML = originalText
        downloadBtn.disabled = false
      }
    },
    payInvoice(invoice) {
      // 模拟支付过程
      if (confirm(`确定要支付发票 ${invoice.invoiceNumber} (SGD ${invoice.amount.toFixed(2)}) 吗？`)) {
        // invoice.status = 'paid'
        // alert('支付成功！')
        // this.S$router.push({
        //   path: '/payment',
        //   query: {
        //     registrationId: invoice.registrationId,
        //   }
        // })
        const res =  apiService.abstracts.createAbstractBill({
          // id: invoice.id
          id: 23
        })
        console.log(res)
        if (res.Object.data.data.code === 1) {
          const res2 =  apiService.abstracts.payAbstractBill({
            id: res.Object.data.data.data.order_no
          })
          if (res2.data.code === 1) {
            alert('支付成功！')
          } else {
            alert('支付失败！')
          }
        } else {
          alert('支付失败！')
        }

      }
    }
  }
}
</script>

<style scoped>
.invoice-item {
  margin-bottom: 20px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  transition: box-shadow 0.3s ease;
}

.invoice-item:hover {
  box-shadow: 0 4px 8px rgba(0,0,0,0.15);
}

.invoice-details p {
  margin-bottom: 5px;
  font-size: 14px;
}

.amount {
  font-weight: bold;
  color: #28a745;
  font-size: 18px;
}

.invoice-status {
  margin-bottom: 10px;
}

.invoice-actions {
  margin-top: 15px;
}

.card-title {
  color: #2c3e50;
  margin-bottom: 15px;
}

.bg-primary {
  background-color: #007bff !important;
}

.bg-warning {
  background-color: #ffc107 !important;
}

.bg-danger {
  background-color: #dc3545 !important;
}
</style> 